<template>
  <div class="animated fadeIn">

    <div class="card-body">
        
            <vue-good-table
              mode="remote"
              ref="my-table"
            
              :totalRows="totalRecords"
              :columns="columns4"
              :rows="rows4"
              :pagination-options="{
                enabled: true,
                perPage: 5,
              }"
              styleClass="vgt-table striped bordered table-sm condensed"
            >
              <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'action'">
                  
                  <!-- <i
                    class="fa fa-eye"
                    @click="viewCard(props.row)"
                    style="color: #63c2de; font-size: 20px; cursor: pointer;"
                  ></i> -->
                  <span >
                     <i
                      class="fa fa-pencil"
                      style="color: #63c2de; font-size: 20px; cursor: pointer;"
                      title="Edit Scheme"
                      v-on:click="editDetails(props.row)"
                    ></i>
                    <i
                      class="fa fa-trash-o"
                      style="color: #f44336; font-size: 20px; cursor: pointer;"
                      title="Delete"
                      v-on:click="removeScheme(props.row)"
                    ></i>
        

                    <!-- <router-link :to="{ name: 'Edit Purchase', params: { purchaseId: props.row.purchase_id, shopId: props.row.est_shop_id }}"> -->
                   
                    <!-- </router-link> -->
                    <!--<a @click="editpro2(props.row)" style="color:#63c2de;font-size: 20px; cursor: pointer;">Return</a>-->
                  </span>
                  <!-- <span v-else>
                    <i
                      class="fa fa-trash"
                      style="color: grey !important; font-size: 20px;"
                    ></i>
                    <i
                      class="fa fa-pencil"
                      style="color: grey !important; font-size: 20px;"
                    ></i>
                   <a style="color:grey !important;font-size: 20px;">Return</a>
                  </span> -->
                </span>
                <span v-if="props.column.field == 'labelname'">
                <h6>Cash free payment Details</h6>
                </span>
                
                <span v-else-if="props.column.field == 'gst_total'">
                  {{
                    (
                      parseFloat(props.row.cgst_amt) +
                      parseFloat(props.row.sgst_amt) +
                      parseFloat(props.row.igst_amt)
                    ).toFixed(2)
                  }}
                </span>

               
                <span v-else-if="props.column.field == 'return'">
                  <span v-if="pur_rights === true">
                    <i
                      class="fa fa-reply"
                      style="color: #63c2de; font-size: 18px; cursor: pointer;"
                      v-on:click="editpro2(props.row)"
                    ></i>
                  </span>
                  <span v-else>
                    <i
                      class="fa fa-reply"
                      style="color: grey !important; font-size: 18px;"
                    ></i>
                  </span>
                </span>
                <span v-else>
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>
            </vue-good-table>
          </div>
         
         
           <b-modal :title="tit" no-close-on-esc no-close-on-backdrop size="lg" class="modal-info" hide-footer v-model="largeModal" @ok="largeModal = false">
      <b-row>
          <b-col sm="6">
              <b-form-group>
                <label for="name">Client ID </label>
                <b-form-input
                  type="text"
                  placeholder="Enter Client Id"
                  autocomplete="off"
                  v-model="cardData.cfp_client_id"
                ></b-form-input>
                <small  class="form-text text-muted"><strong style="color: red;">{{hasErrors.cfp_client_id}}</strong></small>
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group>
                <label for="name"> enter client secret </label>
                <b-form-input
                  type="text"
                  placeholder="Enter client Secret"
                  autocomplete="off"
                  v-model="cardData.cfp_client_secret"
                ></b-form-input>
                 <small  class="form-text text-muted"><strong style="color: red;">{{hasErrors.cfp_client_secret}}</strong></small>
              </b-form-group>
            </b-col>
      </b-row>
    
      <div class="card-footer modal_footer">
        <b-row>
          <b-col sm="12">
            <b-button-group>
              <b-button class="d-sm-down-none btn-sm" v-if="saveBtn" @click.prevent="cardScheme()" variant="primary"><i class="fa fa-dot-circle-o"></i> Save</b-button>
               <b-button class="d-sm-down-none btn-sm" v-if="editBtn" @click.prevent="editDetailsdata()" variant="primary"><i class="fa fa-dot-circle-o"></i> Update</b-button>
            </b-button-group>
          </b-col>
        </b-row>
      </div>
    </b-modal>
    <Spinner v-if="loading"></Spinner>
  </div>
</template>


<style>
.switch.switch-text .switch-label::before,
.switch.switch-text .switch-label::after {
  width: 67% !important;
}
.switch.switch-text {
  width: 74px;
}
.switch.switch-text .switch-input:checked ~ .switch-handle {
  left: 50px;
}
.switch.switch-text .switch-label {
  background-color: red;
}
.selected_row {
  background-color: blue;
}
.modal-title {
  color: black;
  font-weight: bold;
}
</style>
<script>
export default {
  data() {
    return {
         super_user: 3,
        smsStatus:'',
        largeModal: false,
      loading: false,
      msg_id:'',
      totalRecords: 0,
        cardData:{
          sendername:'',
          cfp_id:'',
          cfp_company_id:'',
          cfp_client_id:'',
          cfp_client_secret:'',
          labelname:'"Cashfreepayments"',
         
        },
         active_deactive: '',
         hasErrors:{
          sendername:'',
          cfp_id:'',
          cfp_company_id:'',
          cfp_client_id:'',
          cfp_client_secret:'',
          cfp_regcity_code:'',
        },
      tit:'',
      saveBtn:false,
      editBtn:false,
      mobile_no:'',
      msg:'',
      rows4: [],
        columns4: [ 
          {
          label: "",
          field: "labelname",
          width: "15% !important",
          tdClass: "text-left",
          thClass: "text-left",
        },
     
        {
          label: "Client Id",
          field: "client_id",
          width: "15% !important",
          tdClass: "text-left",
          thClass: "text-left",
        },
        {
          label: "Client Secret",
          field: "client_secret",
          width: "20% !important",
          tdClass: "text-left",
          thClass: "text-left",
        },

        {
          label: "Action",
          field: "action",
          width: "10% !important",
          thClass: "text-center",
          tdClass: "text-center",
        },
      ],
  
    }
  },
  created(){
     var _this = this;
    //this.customerCards();
     this.cashdetails();
   
      this.super_user = _this.$store.getters.get_super_user;
  },
  methods:{

     cashdetails(){
       
      var _this=this
      this.$http.get('/api/Cashfreepayments/cashfreedetails') .then(function (response) {
        _this.rows4 =response.data
        console.log(_this.rows4 )
     
     
        
      })
      .catch(function (error) {

      });
    },

      
          cardScheme(){ 
        var _this = this
        this.submit_true=0;
      if (this.submit_true==0){
           this.loading=true
          //this.largeModal=false;
             if(_this.cardData.cfp_client_id==null || _this.cardData.cfp_client_id=='' ){
              _this.loading=false;
            this.hasErrors.cfp_client_id="Please Enter  client_id"
          }else if(_this.cardData.cfp_client_secret  ==null || _this.cardData.cfp_client_secret==''){
               _this.loading=false;
              _this.hasErrors.cfp_client_secret="Please Enter client secret"
              }else if(_this.cardData.cfp_regcity_code  ==null || _this.cardData.cfp_regcity_code ==''){
               _this.loading=false;
              _this.hasErrors.cfp_regcity_code ="Please registered city code"

              }else{
                 var user=null;
            _this.submitschemevalue(_this)
            
              }
         
             }
        
           
          
            },
    editDetails(company_id){
      this.reset();
      this.saveBtn = false
      this.editBtn = true
      this.tit = "Update Details"
      this.largeModal = true
      this.cardData.cfp_id = company_id.id
      this.cardData.cfp_client_id = company_id.client_id
      this.cardData.cfp_client_secret = company_id.client_secret
      this.cardData.cfp_regcity_code = company_id.regcity_code
     
    },
    editDetailsdata(){ 
          var _this = this        
          this.submit_true=0;
         
          if (this.submit_true==0){
          this.loading=true
          //this.largeModal=false;
          if(_this.cardData.cfp_client_id  ==null || _this.cardData.cfp_client_id==''){
               _this.loading=false;
              _this.hasErrors.client_id="Please Client Id"
              }else if(_this.cardData.cfp_client_secret  ==null || _this.cardData.cfp_client_secret ==''){
               _this.loading=false;
              _this.hasErrors.cfp_client_secret ="Please Enter Client secret"
              }else if(_this.cardData.cfp_regcity_code  ==null || _this.cardData.cfp_regcity_code ==''){
               _this.loading=false;
              _this.hasErrors.cfp_regcity_code ="Please Enter Registered city code"
              }else{
                 var user=null;
            _this.submitDetailsvalue1(_this)
              }
             }
          },
          submitDetailsvalue1(_this){
             console.log('as')
              let res = {
                          id:this.cardData.cfp_id,
                          client_id:this.cardData.cfp_client_id,
                          client_secret:this.cardData.cfp_client_secret, 
                          regcity_code:this.cardData.cfp_regcity_code,           
                        }
                        console.log(this.cardData.cfp_id)
               this.$http.post('/api/Cashfreepayments/cashfreeupdated', res)
                .then(function (response) {            
                if(response.status==200){
                _this.message = true
                 _this.message = "Details Updated Successfully"
                 _this.largeModal = false;
                 alert(" Edited Successfully")
                 setTimeout(function(){ _this.message='';}, 2000);
                 _this.loading=false;
                  _this.cashdetails();
                
               }else{
                console.log('error')
               }
            
                })
                  .catch(function (error) {
                    _this.loading=false
                    console.log(error)
                  });

            },
    reset(){
      this.cardData.cfp_client_id = ''
      this.cardData.cfp_client_secret = ''
      this.cardData.cfp_regcity_code = ''

    
      this.hasErrors.cfp_client_id = ''
      this.hasErrors.cfp_client_secret = ''
      this.hasErrors.cfp_regcity_code = ''
      
    },
    
  },
}
</script>



// WEBPACK FOOTER //
// src/views/gold/cashfreepayment.vue